import React from 'react';
import {
  defaultRules,
  inlineRegex,
  sanitizeUrl,
  parserFor,
  ruleOutput,
  reactFor,
} from 'simple-markdown';

// Matches all non-newline characters, followed by special characters, newlines, URLs, or the end of
// the string (which should match all of the other rules).
const TEXT_MATCH = /^[^\n]+?(?=[^0-9A-Za-z\s\u00c0-\uffff]|\n|\w+:\S|$)/;

const customRules = {
  // Don't use those rules from defaultRules
  // heading: defaultRules.heading,
  // nptable: defaultRules.nptable,
  // lheading: defaultRules.lheading,
  // hr: defaultRules.hr,
  // inlineCode: defaultRules.inlineCode,
  // codeBlock: defaultRules.codeBlock,
  // fence: defaultRules.fence,
  // blockQuote: defaultRules.blockQuote,
  // def: defaultRules.def,
  // table: defaultRules.table,
  // autolink: defaultRules.autolink,
  // mailto: defaultRules.mailto,
  // reflink: defaultRules.reflink,
  // refimage: defaultRules.refimage,
  // newline: defaultRules.newline,
  // escape: defaultRules.escape,

  // Custom rules for chat-style markup:
  // simple-markdown outputs a <div> instead of a <p> by default.
  // so we change the paragraph rule.
  paragraph: {
    ...defaultRules.paragraph,
    react: (node, output, state) => (
      <p key={state.key}>{output(node.content, state)}</p>
    ),
  },
  // Automatically convert URLs to <a> tags.
  url: defaultRules.url,
  // custom [link](http://url/) to open in new tab
  link: {
    ...defaultRules.link,
    react: (node, output, state) => (
      <a
        key={state.key}
        href={sanitizeUrl(node.target)}
        target="_blank"
      >
        {output(node.content, state)}
      </a>
    ),
  },
  // img tags ![](http://url/)
  image: defaultRules.image,
  // _italic_
  simpleItalic: {
    ...defaultRules.em,
    match: inlineRegex(/^_([\s\S]+?)_(?!_)/),
  },
  // *bold*
  simpleBold: {
    ...defaultRules.strong,
    match: inlineRegex(/^\*([\s\S]+?)\*(?!\*)/),
  },
  // ~~strikethrough~~
  del: defaultRules.del,
  // * list \n\n
  // 1. no list \n\n
  list: defaultRules.list,
  // Convert newlines to <br>.
  br: {
    ...defaultRules.br,
    match: (source) => /^\n/.exec(source),
    react: (node, output, state) => <br key={state.key} />,
  },
  // Parse plain text, but don't eat newlines that aren't preceded by two spaces or another newline
  // like defaultRules.text does, because we want to allow single newlines to be converted to <br>
  // tags without requiring two spaces at the end of the line like Markdown.
  //
  // NOTE: With simple-markdown the `text` rule must match anything that none of your other rules
  // should match or else parsing might fail with an error that no rules matched the text. This
  // means that you might have to update the regex for `text` any time you update another rule,
  // making it potentially difficult to maintain.
  text: {
    ...defaultRules.text,
    match: inlineRegex(TEXT_MATCH),
  },
  // NOTE: the br and text rules should always both appear at the end of any parsers made with these
  // rules, so the br rule can "eat" all newlines and the text rule can eat all other characters. If
  // these rules aren't included, then there may be no rules to fall back on and parsing may fail.
};

export const markupParser = parserFor(customRules);

export const reactRenderer = reactFor(ruleOutput(customRules, 'react'));
